import axios from "axios";

const LOGIN_URL = "/auth/login";
const LOGOUT_URL = "/auth/logout";
const REFRESH_URL = "/auth/refreshToken";

export function getAccessToken(loginToken) {
  return axios.post(LOGIN_URL,
    {
      loginToken
    },
    {
      headers: {'Content-Type': 'application/json'}
    });
}

export function loginWithTokens({userID, accessToken, idToken, refreshToken, expire}) {
  return axios.post(LOGIN_URL, {
    userID,
    accessToken,
    idToken,
    refreshToken,
    expireTime: expire
  })
}

export function logout() {
  return axios.post(LOGOUT_URL, {});
}

export function refreshToken () {
  return axios
    .post(REFRESH_URL, {})
    .then(response => {
      const {error, data} = response.data;
      if (error < 0) throw new Error();

      return data.newAccessToken
    })
}

